import { render } from "./ClientsTable.vue?vue&type=template&id=37363f8f"
import script from "./ClientsTable.vue?vue&type=script&lang=js"
export * from "./ClientsTable.vue?vue&type=script&lang=js"

import "./ClientsTable.vue?vue&type=style&index=0&id=37363f8f&lang=scss"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__